// ============================================================================
// Header — sticky shrink, mega dropdown, mobile off-canvas menu
// Terser TDZ workaround: declare DOM refs at top, helpers in middle, init at bottom.
// ============================================================================
(function ($) {
    'use strict';

    $(function () {
        // DOM refs (declared up-front so hoisted helpers can use them)
        const $header     = $('#header');
        if (!$header.length) return;

        const $body       = $('body');
        const $window     = $(window);
        // Hysteresis (8/140) + 600ms state lock defeat scroll-anchor flicker; pair with `body { overflow-anchor: none }`.
        const compactAt   = 140;
        const expandAt    = 8;
        const stateLockMs = 600;
        let lastStateChange = 0;

        const $dropdown   = $header.find('[data-dropdown-panel="products"]');
        const $desktopHome = $header;
        const $mobileHome  = $header.find('[data-dropdown="products"]');
        const mobileMql    = window.matchMedia('(max-width: 1279px)');
        const hoverMql     = window.matchMedia('(hover: hover) and (min-width: 1280px)');

        const $triggers   = $header.find('[data-dropdown]');

        let scrollScheduled = false;
        let hoverTimer;

        // Helpers
        function applyScrollState() {
            const now = Date.now();
            if (now - lastStateChange < stateLockMs) return;

            const y = $window.scrollTop();
            const isCompact = $header.hasClass('is-compact');
            if (!isCompact && y > compactAt) {
                $header.addClass('is-compact');
                lastStateChange = now;
            } else if (isCompact && y < expandAt) {
                $header.removeClass('is-compact');
                lastStateChange = now;
            }
        }

        function openDropdown(name) {
            const $trigger = $header.find('[data-dropdown="' + name + '"]');
            const $panel   = $header.find('[data-dropdown-panel="' + name + '"]');

            $triggers.not($trigger).removeClass('is-open')
                .find('button').attr('aria-expanded', 'false');
            $header.find('[data-dropdown-panel]').not($panel).removeClass('is-open')
                .attr('aria-hidden', 'true');

            $trigger.addClass('is-open').find('button').attr('aria-expanded', 'true');
            $panel.addClass('is-open').attr('aria-hidden', 'false');
        }

        function closeAllDropdowns() {
            $triggers.removeClass('is-open').find('button').attr('aria-expanded', 'false');
            $header.find('[data-dropdown-panel]').removeClass('is-open').attr('aria-hidden', 'true');
        }

        function relocateDropdown() {
            if (!$dropdown.length) return;
            closeAllDropdowns();
            if (mobileMql.matches) {
                if (!$.contains($mobileHome[0], $dropdown[0])) {
                    $mobileHome.append($dropdown);
                }
            } else {
                if ($dropdown.parent()[0] !== $desktopHome[0]) {
                    $desktopHome.append($dropdown);
                }
            }
        }

        function openMenu() {
            $header.addClass('is-menu-open');
            $body.addClass('is-menu-locked');
            $header.find('[data-toggle="menu"]').first().attr('aria-expanded', 'true');
        }

        function closeMenu() {
            $header.removeClass('is-menu-open');
            $body.removeClass('is-menu-locked');
            $header.find('[data-toggle="menu"]').first().attr('aria-expanded', 'false');
            closeAllDropdowns();
        }

        function toggleMenu() {
            if ($header.hasClass('is-menu-open')) closeMenu();
            else openMenu();
        }

        function syncToViewport() {
            if (!mobileMql.matches && $header.hasClass('is-menu-open')) closeMenu();
            relocateDropdown();
        }

        // Bindings — sticky shrink
        applyScrollState();
        $window.on('scroll', function () {
            if (scrollScheduled) return;
            scrollScheduled = true;
            window.requestAnimationFrame(function () {
                applyScrollState();
                scrollScheduled = false;
            });
        });

        // Dropdown click toggle — covers both the desktop mega-dropdown and the mobile accordion
        $header.on('click', '[data-dropdown] > button', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const name = $(this).closest('[data-dropdown]').data('dropdown');
            const $panel = $header.find('[data-dropdown-panel="' + name + '"]');
            if ($panel.hasClass('is-open')) closeAllDropdowns();
            else openDropdown(name);
        });

        // Desktop hover open/close
        $header.on('mouseenter', '[data-dropdown], [data-dropdown-panel]', function () {
            if (!hoverMql.matches) return;
            clearTimeout(hoverTimer);
            const name = $(this).data('dropdown') || $(this).data('dropdown-panel');
            openDropdown(name);
        });
        $header.on('mouseleave', '[data-dropdown], [data-dropdown-panel]', function () {
            if (!hoverMql.matches) return;
            hoverTimer = setTimeout(closeAllDropdowns, 150);
        });

        // Outside click + Escape
        $(document).on('click', function (e) {
            if (!$(e.target).closest('#header').length) closeAllDropdowns();
        });
        $(document).on('keydown', function (e) {
            if (e.key === 'Escape') {
                closeAllDropdowns();
                closeMenu();
            }
        });

        // Burger / off-canvas menu
        $header.on('click', '[data-toggle="menu"]', function (e) {
            e.preventDefault();
            toggleMenu();
        });

        // Close mobile menu on nav link tap
        $header.on('click', '.header__nav a', function () {
            if (mobileMql.matches) closeMenu();
        });

        if (mobileMql.addEventListener) mobileMql.addEventListener('change', syncToViewport);
        else if (mobileMql.addListener) mobileMql.addListener(syncToViewport);

        // Initial DOM placement
        relocateDropdown();
    });
})(jQuery);
